<template>
    <Breadcrumb separator=">">
        <template v-for="item in currentPath">
            <BreadcrumbItem v-if="item.path === ''">
                {{ item.title }}
            </BreadcrumbItem>
            <BreadcrumbItem v-else :to="{ name: item.path,params: item.params,query:item.query}">
                {{ item.title }}
            </BreadcrumbItem>
        </template>
    </Breadcrumb>
</template>

<script>

    export default {
        name: 'breadcrumbNav',
        props: {
            currentPath: Array
        },
        methods: {
            gotoNextPage (path, params, query) {
                this.$router.push({
                    name: path,
                    params: params,
                    query: query
                })
            }
        }
    };
</script>
<style lang="scss">
    .ivu-breadcrumb {
        color     : unset;
        font-size : 14px;
    }
    .ivu-breadcrumb > span:last-child {
        font-weight : unset;
        color       : #515a6e;
    }

    .ivu-breadcrumb-item-separator {
        margin: 0 8px;
        color: #565656;
    }
</style>

